import { Components, Theme } from '@mui/material/styles';

export const flowOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline, & .MuiPickersOutlinedInput-notchedOutline': {
          '&, &:not(.Mui-error)': {
            borderColor: 'currentColor',
          },
        },
      },
    },
  },
};
